import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneSubject from '../ones/OneSubject';
import { MdCheck, MdSms, MdSubject, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			//appContext.getMySubjects(),
			//appContext.getMyClassrooms(),
			//appContext.getMyExamCycles(),
			//appContext.getMyStreams(),
		])
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allSubjects])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							My Activities
						</h6>
					</div>

					<div className="col-12 col-md-6">
						<div
							className="card"
							style={{
								cursor: "pointer"
							}}
							onClick={() => {
								appContext.navTo({
									item: 'my_activities',
									subItem: 'my_subjects',
								})
							}}
						>
							<div className="card-body">
								<h6
									className="card-title"
								>
									My Subjects
								</h6>

								<h6
									className="text-end"
								>
									<MdSubject size={42}/>
								</h6>								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<div
							className="card"
							style={{
								cursor: "pointer"
							}}
							onClick={() => {
								appContext.navTo({
									item: 'my_activities',
									subItem: 'my_exam_cycles',
								})
							}}
						>
							<div className="card-body">
								<h6
									className="card-title"
								>
									My Exam Cycles
								</h6>

								<h6
									className="text-end"
								>
									<MdSubject size={42}/>
								</h6>									
							</div>
						</div>
					</div>
					
					<div className="col-12 col-md-6 d-none">
						<div
							className="card"
							style={{
								cursor: "pointer"
							}}
							onClick={() => {
								appContext.navTo({
									item: 'my_activities',
									subItem: 'my_classrooms',
								})
							}}
						>
							<div className="card-body">
								<h6
									className="card-title"
								>
									My Classrooms
								</h6>

								<h6
									className="text-end"
								>
									<MdSubject size={42}/>
								</h6>								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-6 d-none">
						<div
							className="card"
							style={{
								cursor: "pointer"
							}}
							onClick={() => {
								appContext.navTo({
									item: 'my_activities',
									subItem: 'my_streams',
								})
							}}
						>
							<div className="card-body">
								<h6
									className="card-title"
								>
									My Streams
								</h6>

								<h6
									className="text-end"
								>
									<MdSubject size={42}/>
								</h6>								
							</div>
						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}